import {
  FETCH_ACCOUNTS,
  SET_ACCOUNTS,
  SAVE_ACCOUNT_REQUEST,
  SAVE_ACCOUNT_SUCCESS,
  SAVE_ACCOUNT_FAILURE,
  ACCOUNT_SET_FILTER,
  ACCOUNT_MODAL_OPEN,
  ACCOUNT_MODAL_CLOSE,
  AccountCategory,
} from './actions';

export interface AccountState {
  list: AccountCategory[];
  loading: boolean;
  saving: boolean;
  error?: string;
  filterName: string;
  modalOpen: boolean;
  editing: AccountCategory | null;
}

const initialState: AccountState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,

  filterName: '',
  modalOpen: false,
  editing: null,
};

export default function accountManagerReducer(
  state: AccountState = initialState,
  action: any
): AccountState {
  switch (action.type) {
    case FETCH_ACCOUNTS:
      return { ...state, loading: true, error: undefined };

    case SET_ACCOUNTS:
      return { ...state, loading: false, list: action.payload ?? [] };

    case SAVE_ACCOUNT_REQUEST:
      return { ...state, saving: true, error: undefined };

    case SAVE_ACCOUNT_SUCCESS:
      return { ...state, saving: false };

    case SAVE_ACCOUNT_FAILURE:
      return { ...state, saving: false, error: action.error };

    case ACCOUNT_SET_FILTER:
      return { ...state, filterName: action.payload ?? '' };

    case ACCOUNT_MODAL_OPEN:
      return { ...state, modalOpen: true, editing: action.payload ?? null };

    case ACCOUNT_MODAL_CLOSE:
      return { ...state, modalOpen: false, editing: null };

    default:
      return state;
  }
}